var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLeadQialificationGoal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.5 6H10.25a.25.25 0 00-.25.25V8c0 .137.113.25.25.25H28.5a.25.25 0 00.25-.25V6.25A.25.25 0 0028.5 6zm0 8.875H10.25a.25.25 0 00-.25.25v1.75c0 .137.113.25.25.25H28.5a.25.25 0 00.25-.25v-1.75a.25.25 0 00-.25-.25zm0 8.875H10.25A.25.25 0 0010 24v1.75c0 .137.113.25.25.25H28.5a.25.25 0 00.25-.25V24a.25.25 0 00-.25-.25zM3.25 7.125a1.75 1.75 0 103.5 0 1.75 1.75 0 00-3.5 0zm0 8.875a1.75 1.75 0 103.5 0 1.75 1.75 0 00-3.5 0zm0 8.875a1.75 1.75 0 103.5 0 1.75 1.75 0 00-3.5 0z",
    fill: "#ADC6FF"
  })));
}

export default __webpack_public_path__ + "./fonts/lead-qialification-goal.95c8ebf2fb84c9cba3a017aab5e10d44.svg";
export { SvgLeadQialificationGoal as ReactComponent };